import React, { useState } from 'react';

import { useParams } from 'react-router-dom';

import { useSelector } from 'react-redux';

import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CloudSyncOutlined,
  CreditCardFilled,
} from '@ant-design/icons';

import { Steps, Typography } from 'antd';

import {
  FormAddButton as ActionButton,
  RibbonButton,
  StyledModal,
} from 'common/components';

import {
  ActiveProductCharge,
  ProductsActiveProcessing,
} from './components/make-product-active';

import {
  modalBodyProductActiveHeight,
  modalMakeProductActiveWidth,
} from './components/ixone-credit-card';

import selectorsGridView from 'common/components/grid-view/controllers/selectors';

import { useGetProductFullView, useVisibleModal } from 'hooks';
import { useCheckCreditCardPermission } from 'hooks/useCheckCreditCardPermission';
import { useCheckPaymentTermMonthAndMemberStatusCreditReview } from 'hooks/member/useCheckPaymentTermMonthAndMemberStatusCreditReview';
import { useBrokerHasInitiateBillingEvent } from 'hooks/impersonate/useBrokerHasInitiateBillingEvent';

import { toArray } from 'utils/array';
import { disableMakeActiveProduct } from 'utils/ixone-capture';

import './MakeProductActive.less';

const { Step } = Steps;

const MakeProductActive = ({ isFullView = false }) => {
  const [visibleModal, { onModal, offModal }] = useVisibleModal();

  const { id: productId } = useParams();

  const { canPayViaCreditCard: hasPermissionActiveProduct } =
    useCheckCreditCardPermission();
  const isPaymentTermMonthAndMemberStatusCreditReview =
    useCheckPaymentTermMonthAndMemberStatusCreditReview();
  const brokerHasInitiateBillingEvent = useBrokerHasInitiateBillingEvent();

  const { productFull } = useGetProductFullView({
    productId,
    enabled: Boolean(productId && isFullView),
  });

  const selectProductGrid = useSelector(
    selectorsGridView.makeSelectDetailCurrentITemsSelection()
  );

  const selectedProductIdsGrid =
    selectProductGrid?.map((product) => parseInt(product?.id)) ?? [];

  const productIds = isFullView ? toArray(productId) : selectedProductIdsGrid;

  const disabledGridView =
    selectProductGrid?.length === 0 ||
    selectProductGrid?.some((product) =>
      Boolean(disableMakeActiveProduct(product))
    );

  const disabledFullView = disableMakeActiveProduct(productFull);

  return (
    <>
      <RibbonButton
        disabled={
          isFullView
            ? !hasPermissionActiveProduct ||
              isPaymentTermMonthAndMemberStatusCreditReview ||
              disabledFullView ||
              !brokerHasInitiateBillingEvent
            : !hasPermissionActiveProduct ||
              isPaymentTermMonthAndMemberStatusCreditReview ||
              disabledGridView ||
              !brokerHasInitiateBillingEvent
        }
        size='small'
        icon={<CloudSyncOutlined />}
        label={'Make Product Active'}
        onClick={onModal}
      />
      <MakeProductActiveStep
        productIds={productIds}
        offModal={offModal}
        visibleModal={visibleModal}
        isFullView={isFullView}
      />
    </>
  );
};

const MakeProductActiveStep = ({
  productIds,
  offModal,
  visibleModal,
  isFullView,
  ...otherProps
}) => {
  const [currentStep, setCurrentStep] = useState(0);

  const handleCancelModal = () => {
    offModal();
    setCurrentStep(0);
  };

  const modalProps = {
    title: 'Make Product Active',
    wrapClassName: 'make-product-active__modal-step',
    visible: visibleModal,
    onCancel: handleCancelModal,
    width: modalMakeProductActiveWidth,
    bodyStyle: {
      overflow: 'hidden',
      marginBottom: 6,
      ...modalBodyProductActiveHeight,
    },
    maskClosable: false,
    footer: null,
    destroyOnClose: true,
    ...otherProps,
  };

  return (
    <>
      {visibleModal && (
        <StyledModal {...modalProps}>
          <Steps
            current={currentStep}
            style={{
              width: '80%',
              margin: 'auto',
              marginTop: 12,
            }}
          >
            <Step
              key={0}
              title={
                <Typography.Text strong style={{ fontSize: 16 }}>
                  Update Requirements
                </Typography.Text>
              }
            />
            <Step
              key={1}
              title={
                <Typography.Text strong style={{ fontSize: 16 }}>
                  Charge
                </Typography.Text>
              }
              icon={<CreditCardFilled />}
            />
          </Steps>

          <div
            style={{ paddingTop: 6 }}
            className='make-product-active__section'
          >
            {currentStep === 0 ? (
              <ProductsActiveProcessing productIds={productIds}>
                <ActionButton
                  text='Next'
                  icon={<ArrowRightOutlined />}
                  onClick={() => setCurrentStep(currentStep + 1)}
                />
              </ProductsActiveProcessing>
            ) : (
              <ActiveProductCharge
                onCancel={handleCancelModal}
                productIds={productIds}
                isFullView={isFullView}
              >
                <ActionButton
                  text='Back'
                  icon={<ArrowLeftOutlined />}
                  type='default'
                  onClick={() => setCurrentStep(currentStep - 1)}
                />
              </ActiveProductCharge>
            )}
          </div>
        </StyledModal>
      )}
    </>
  );
};

export default MakeProductActive;
